// extracted by mini-css-extract-plugin
export default {"container":"NotFound_container__fKxqf","oop":"NotFound_oop__Mrf-0","looks":"NotFound_looks__bOFug"};